import {Button, Fab, useMediaQuery} from '@material-ui/core';
import {Add, CloudUpload} from '@material-ui/icons';
import * as ModalActions from 'Core/ducks/modal';
import React from 'react';
import RequireAtLeastOneScope from 'Shared/components/RequireAtLeastOneScope';
import {Scope} from 'Shared/constants/Scope';
import 'Users/components/UserAdministration/AddUsersMenu.sass';
import {UserViewProps} from 'Users/components/UserAdministration/UserAdministration';
import {UserRouteConstants} from 'Users/Routes';

const AddUsersMenu = (props: UserViewProps) => {
  const isDesktop = useMediaQuery((theme: any) => theme.breakpoints.up('lg'));

  return isDesktop ? (
    <div className="add-agents-menu">
      <Button
        variant="contained"
        color="primary"
        onClick={() => props.history.push(UserRouteConstants.ADD_USER)}
        className="user-administration__add-user-button"
      >
        <i className="fa fa-plus" />
        &nbsp;Add User
      </Button>
      {
        // <RequireAtLeastOneScope scopes={[Scope.UploadAgents, Scope.UploadEnrollTrackUser]}>
        //   <Button
        //     color="primary"
        //     variant="contained"
        //     onClick={() =>
        //       props.showModal(
        //         ModalActions.ModalState.UsersRegistration({
        //           onClose: props.fetchUsers,
        //         })
        //       )
        //     }
        //   >
        //     <i className="fa fa-upload" />
        //     &nbsp;&nbsp;Upload Users
        //   </Button>
        // </RequireAtLeastOneScope>
      }
    </div>
  ) : (
    <>
      <Fab
        color="primary"
        className="users-menu__mobile-actions"
        onClick={() => props.history.push(UserRouteConstants.ADD_USER)}
      >
        <Add className="users-menu__plus-icon" />
      </Fab>
      {/* <RequireAtLeastOneScope scopes={[Scope.UploadAgents, Scope.UploadEnrollTrackUser]}>
        <Fab
          className="users-menu__mobile-bulk-upload-button"
          onClick={() => {
            props.showModal(
              ModalActions.ModalState.UsersRegistration({
                onClose: props.fetchUsers,
              })
            );
          }}
          color="primary"
        >
          <CloudUpload />
        </Fab>
      </RequireAtLeastOneScope> */}
    </>
  );
};

export default AddUsersMenu;
